const styles = (theme) => ({
  botao: {
    // Discreto em repouso para não competir com o conteúdo, opaco no hover.
    opacity: 0.55,
    transition: "opacity 0.15s ease-in-out",
    "&:hover": { opacity: 1 },
  },
  icone: {
    fontSize: "16px",
  },
});

export default styles;
